<template>
    <v-layout align-center justify-center class="upload_bg">
         <v-toolbar fixed flat class="transparent" style="color:white;">
            Attendance Upload
            <v-spacer></v-spacer>
            <v-toolbar-items>       
                <v-btn :disabled="uploading" dark flat @click="closeDialog">Close</v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-flex xs12 sm7>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                {{errorMessage}}
            </v-alert>
            <v-alert :value="true" color="info" icon="info" outline>
                {{uploadReminder}}
            </v-alert>
            <v-alert v-if="overwriteExistingAttendance" :value="true" color="warning" icon="warning" outline>
                <b>IMPORTANT.</b> This will overwrite any existing attendance records that match the uploaded data.
            </v-alert>
            <v-alert v-if="uploading" :value="true" color="info" icon="info" outline>
                Uploading...
            </v-alert>
            <div class="text-xs-center">
                <v-card class="elevation-1" >
                    <v-toolbar flat height="45px">
                        <v-switch
                            v-model="overwriteExistingAttendance"
                            label="Overwrite Existing Attendance"
                            color="primary"
                            hide-details
                            style="margin:0px 0px 5px 5px;"
                            @change="setOverwriteExistingAttendance"
                        ></v-switch>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <vue-dropzone ref="myVueDropzone" 
                        class="form-upload"
                        id="dropzone" 
                        v-show="showUpload"
                        :options="dropzoneOptions"
                        v-on:vdropzone-success="uploadSuccess"
                        v-on:vdropzone-file-added="fileAdded"
                        ></vue-dropzone>
                </v-card>
            </div>
         </v-flex> 
     </v-layout>
 </template>
 <script>

import axios from 'axios'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import pageKeys from '@/common/pagekeys'

export default {
    name: 'upload-attendance',
    components: {
        vueDropzone: vue2Dropzone
    },
    data () {
        return {
            userId: 0,   
            img: null,   
            showUpload: true,      
            dropzoneOptions: {                    
                url: `${axios.defaults.baseURL}AttendanceUpload/upload`,    
                headers: { 
                    "Authorization": `Bearer ${localStorage.token}`,
                    "page_key": pageKeys.attendance_upload,
                    "session_id": localStorage.sessionId,
                    "source": "Customer"
                },
                params: {
                    cutOffId: null,
                    teamId: null,
                    overwriteExistingAttendance: false
                },
                addRemoveLinks: true,
                dictDefaultMessage: "<br><b class='headline'><u>Drag your file or click here to browse</u><b><br><br><p class='caption'>Maximum 5MB per file.<br>Accepted files types: excel (*.xlsx, *.xls)</p>",
                maxFiles: 1,
                acceptedFiles: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
                maxFilesize: 5,   //5mb
                init: function() {
                   this.on("error", function(file, message) {
                       const errorEl = file.previewElement.querySelector('.dz-error-message');
                       if (errorEl) {
                           errorEl.addEventListener('click', () => {
                               this.removeFile(file);
                           });
                       }
                   });
                }
            },
            uploadReminder: 'Make sure to use the Upload Template file for the selected CutOff period.',
            uploading: false,
            error: false,
            errorMessage: '',
            selectedCutoffId: null,
            overwriteExistingAttendance: false
        }
    },
    methods: {
        setOverwriteExistingAttendance(data) {
            this.dropzoneOptions.params.overwriteExistingAttendance = this.overwriteExistingAttendance
        },
        setData(selectedCutoffId){
            this.uploading = false
            this.selectedCutoffId = selectedCutoffId
            this.dropzoneOptions.params.cutOffId = selectedCutoffId
            this.dropzoneOptions.params.teamId = this.$store.state.selectedTeamId
        },
        fileAdded(file) {
            this.uploading = true
        },
        uploadSuccess(file, response) {
            this.error = false
            this.uploading = false
            this.$emit('send', response)
            this.$emit('update:dialogUpload', false)
        },
        closeDialog() {
            this.showUpload=true
            this.$emit('update:dialogUpload', false)
        }
    },
    created() {}
}
 </script>
 <style scoped>
.upload_bg {
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: rgba(0, 0, 0, 0.9)
}
.form-upload {
    height:250px;
    margin:15px 0px 10px 0px;
    padding:0px 50px 0px 50px;
    border: 1px dashed darkgray;
}

/* ==========================================================================
   DROPZONE VUE-DEEP STYLING OVERRIDES (LIGHT BACKGROUND MINIMALIST LOOK)
   ========================================================================== */
::v-deep #dropzone {
    /* Changed to a dark translucent border for high contrast against light backdrops */
    border-radius: 8px;
    /* Soft light grey background */
    background-color: rgba(0, 0, 0, 0.03) !important;
    /* Dark charcoal text for optimal readability */
    color: #2c3e50 !important;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: 10px;
}
::v-deep #dropzone .dz-preview {
    /* Crisp white preview box to stand out over the light grey dropzone */
    background: #ffffff !important; 
    /* Subtle light grey border */
    border-radius: 8px !important;
    padding: 20px !important;
    width: 280px !important; 
    position: absolute !important;
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    /* Softer, more expanded shadow for light UI designs */
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08) !important;
}
::v-deep #dropzone .dz-preview .dz-image {
    border-radius: 6px !important;
    margin: 0 auto 15px auto !important;
    display: block !important;
    width: 120px !important;
    height: 120px !important;
}
::v-deep #dropzone .dz-preview.dz-error .dz-image {
    display: none !important;
}
::v-deep #dropzone .dz-preview .dz-details {
    /* Text color for file names and details changed to dark grey */
    color: #333333 !important;
    background: transparent !important;
    opacity: 1 !important;
    position: static !important;
    padding: 0 !important;
    text-align: center !important;
    margin-bottom: 12px !important;
}
::v-deep #dropzone .dz-preview .dz-error-message {
    display: none !important; 
}
::v-deep #dropzone .dz-preview.dz-error .dz-error-message {
    position: static !important; 
    opacity: 1 !important;
    display: block !important;
    /* Keeps a vibrant error red that pops cleanly on white backgrounds */
    background: #FF5252 !important;
    color: white !important;
    border-radius: 4px !important;
    padding: 12px 16px !important;
    font-size: 13px !important;
    font-weight: bold !important;
    text-align: center !important;
    margin: 5px 0 0 0 !important;
    width: 100% !important;
    box-sizing: border-box !important;
    cursor: pointer !important;
    transition: background-color 0.2s ease;
}
::v-deep #dropzone .dz-preview.dz-error .dz-error-message:hover {
    background-color: #D32F2F !important;
}
::v-deep #dropzone .dz-preview .dz-error-message:after {
    display: none !important;
}
::v-deep #dropzone .dz-preview .dz-success-mark,
::v-deep #dropzone .dz-preview .dz-error-mark,
::v-deep #dropzone .dz-preview .dz-remove {
    display: none !important;
}

 </style>